import { UserRoleType } from "../types/roles-and-permissions.types";

/**
 * Rol tipi atama / değiştirme politikası (pentest 3.2.2 — yetki yükseltme).
 *
 * Backend ile aynı kurallar (euas-backend/src/modules/users/utils/user-role-type.util.ts:
 * ROLE_ADMIN_ROLE_TYPES, canActorManageRoleTypes):
 *  - Rol tipini değiştirmek ve personel tipinde rol oluşturmak yalnızca
 *    "rol yöneticisi" seviyesine (EDUCATION_MANAGER, CENTRAL_MANAGER) açıktır.
 *  - CENTRAL_MANAGER (Sistem Yöneticisi) tipine yalnızca CENTRAL_MANAGER dokunabilir.
 *  - Diğer kullanıcılar yalnızca öğrenen tiplerinde (USER, INTERN) rol oluşturabilir.
 *
 * UI yalnızca görsel kısıttır; asıl kontrol backend'dedir.
 */
export const ROLE_ADMIN_ROLE_TYPES: readonly number[] = [
  UserRoleType.EDUCATION_MANAGER,
  UserRoleType.CENTRAL_MANAGER,
];

const LEARNER_ROLE_TYPES: readonly number[] = [
  UserRoleType.USER,
  UserRoleType.INTERN,
];

export const isRoleAdmin = (actorRoleTypes: readonly number[]): boolean =>
  actorRoleTypes.some((t) => ROLE_ADMIN_ROLE_TYPES.includes(t));

/** Actor bu rol tipinde rol oluşturabilir / rolü bu tipe çekebilir mi? */
export const canActorAssignRoleType = (
  actorRoleTypes: readonly number[],
  type: number,
): boolean => {
  if (type === UserRoleType.CENTRAL_MANAGER) {
    return actorRoleTypes.includes(UserRoleType.CENTRAL_MANAGER);
  }
  if (isRoleAdmin(actorRoleTypes)) return true;
  return LEARNER_ROLE_TYPES.includes(type);
};

/**
 * Mevcut bir rolün tipi değiştirilebilir mi? Tip değişikliği yalnızca rol
 * yöneticilerine açıktır ve hem mevcut hem hedef tip actor tarafından
 * yönetilebilir olmalıdır.
 */
export const canActorChangeRoleType = (
  actorRoleTypes: readonly number[],
  currentType: number,
): boolean =>
  isRoleAdmin(actorRoleTypes) &&
  canActorAssignRoleType(actorRoleTypes, currentType);
